<div class="stepper-container">
  <div class="stepper">
    @for (step of steps; track step; let i = $index) {
      <div class="step" [class.completed]="step.completed"
        [class.active]="step.active" [class.clickable]="isStepAccessible(step.id)">
        <div class="step-header">
          <div class="step-circle">
            <mat-icon class="icon">{{step.icon}}</mat-icon>
          </div>
          <div class="step-content">
            <div class="step-name">
              {{step.label}}
            </div>
            <div class="step-position" i18n>
              Step {{i+1}}
            </div>
          </div>
        </div>
        @if (i < steps.length - 1) {
          <div class="step-connector"></div>
        }
      </div>
    }
  </div>
</div>